import { render, staticRenderFns } from "./_ClientTabs.vue?vue&type=template&id=15cf9eb0"
import script from "./_ClientTabs.vue?vue&type=script&lang=js"
export * from "./_ClientTabs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports